<template>
  <div>
    <sidebar></sidebar>
    <navbar :pageIndex="pageIndex"></navbar>
    <div class="photos">
      <img src="@/assets/image/product.jpg">
    </div>
    <div class="product-nav">
      <div class="product-nav-item" :style="{'fontWeight':(activeLab==-1?600:'')}"  @click="toType(0)">
        全部
        <div class="active-item" v-if="activeLab==-1"></div>
      </div>
      <div class="product-nav-item" @click="toType(item.id)" :style="{'fontWeight':(activeLab==key?600:'')}"
           v-for="(item,key) in type" :key="key">{{item.typeName}}
        <div class="active-item" v-if="activeLab==key"></div>
      </div>
    </div>
    <div class="default-pic" v-if="productInfo.length==0">
      <img src="../../assets/image/default.png"/>
      <div>暂无此类型 </div>
    </div>
    <div class="product-container">
      <el-row class="box-row">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" v-for="(item,key) in productInfo" :key="key">
          <div class="product-box" @click="toDetail(item.id,item.itemIntro)">
            <img :src="$img + item. itemPcCover" class="product-img">
            <div class="product-info">
              <div class="product-name">{{item.itemName}}</div>
              <div class="product-description">
                {{item.itemIntro}}
              </div>
              <div class="get-more-btn">more+</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
  import navbar from "../../components/navbar";
  import myFooter from "../../components/myFooter";
  import sidebar from "../../components/sidebar";

  export default {
    name: "index",
    components: {
      navbar, myFooter,sidebar
    },
    data() {
      return {
        pageIndex: 2,
        productInfo: [],
        activeBox: -1,
        activeLab:-1,
        type:[]
      }
    },
    created() {
      this.$http.get('/api/item/type/list').then((res)=>{
        // console.log(res)
        this.type = res.data.rows
      })
      this.$http.get('/api/item/info/list').then((res)=>{
        this.productInfo = res.data.rows
      })
    },
    mounted() {
      this.activeLab=this.$store.state.activeLabPc
      // this.productInfo=productInfo.allInfo
    },
    methods: {
      toDetail( id,itemIntro ) {
        this.$router.push({
          path: '/productDetail',
          query: { id,itemIntro }
        })
      },
      toType(id){
        if (id==0){
          this.$http.get('/api/item/info/list').then((res)=>{
            this.productInfo = res.data.rows
          })
        }else{
          console.log(id)
          this.$http.get('/api/item/info/list',{
            params:{
              itemTypeId:id
            }
          }).then((res)=>{
            console.log(res)
            this.productInfo = res.data.rows
          })
        }
        this.$store.commit('editActiveLabMb',id-1)
        this.activeLab = this.$store.state.activeLabMb
      },
    }
  }
</script>

<style scoped>

  .photos {
    width: 100%;
    height: 0;
    padding-bottom: 18.7%;
  }
  .photos img {
    width: 100%;
  }

  .product-nav {
    display: flex;
    width: 72%;
    height: 75px;
    padding-top: 30px;
    box-sizing: border-box;
    margin: 0 auto;
    font-size: 18px;
    position: relative;
    border-bottom: 1px solid #eee;
  }

  .product-nav-item {
    cursor: pointer;
    padding: 0 20px;
    /*width: 90px;*/
    box-sizing: border-box;
    position: relative;
    text-align: center;
  }
  .product-nav-item:hover{
    font-weight: bold;
  }

  .active-item {
    width: 20px;
    height: 0;
    border: 1px solid #333;
    margin: 10px 0 5px -10px;
    position: absolute;
    bottom: -6px;
    left: 50%;
  }

  .product-container {
    width: 100%;
    background-color: #fff;
    /*position: absolute;*/
    /*top: 405px;*/
  }

  .box-row {
    padding-top: 30px;
    width: 72%;
    margin: 0 auto
  }

  .product-box {
    width: 360px;
    height: 450px;
    border-radius: 40px;
    color: #333;
    font-family: 微軟正黑體;
    cursor: pointer;
    transition: all .5s;
    position: relative;
    margin: 110px auto 60px;
    box-shadow: 0 5px 20px #e3e3ed;
  }

  .product-box:hover {
    transform: scale(1.05);
  }

  .product-img {
    position: absolute;
    top: -54px;
    right: 0;
  }
  .product-info{
    /*margin-top: 130px;*/
    padding: 154px 24px 24px;
  }
  .product-name {
    font-size: 20px;
    font-weight: 600;
    color: #000;
  }
  .product-description {
    font-size: 16px;
    margin-top: 10px;
    color: #768087;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    line-height: 180%;
    letter-spacing: 0.1em;
  }
  .get-more-btn {
    width: 110px;
    height: 36px;
    /*border: 2px solid #333;*/
    border-radius: 2em;
    text-align: center;
    font-size: 20px;
    position: absolute;
    bottom: 36px;
    left: 24px;
    z-index: 99;
    background-color: #6676e7;
    color: #ffffff;
    line-height: 30px;
    transition: all .5s;
  }

  .get-more-btn:hover {
    background-color: #3a4ccc;
    transform: scale(1.06);
  }

  @media (max-width: 1300px) {
    .box-row {
      width: 80%;
    }
  }


  .default-pic{
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 30%;
    margin: 50px auto;
  }
  .default-pic img{
    width: 60%;
    /*margin: auto;*/
  }
  .default-pic div{
    margin-top: 50px;
    text-align: center;
    color: #768087;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/index.vue